/**
 * SFrame255 — Complete Final Filings & Close the Estate.
 */

import SettlementStepPage from '../settlement/SettlementStepPage';
import { SETTLEMENT_PHASE_CONFIGS } from '../../utils/settlementFlowConfig';

const step = SETTLEMENT_PHASE_CONFIGS.close.steps.find((s) => s.id === 'cls-3')!;

export default function SFrame255() {
  return (
    <SettlementStepPage
      step={step}
      phase="close"
      overviewRoute="/sframe-250"
      settlementDocumentContext={{ phase: 'close', stepId: 'cls-3' }}
    />
  );
}
